export default __webpack_public_path__ + "2745c061dfc318ec57daaa1c5c2a0d09.ttf";